import { mountApp } from './app/app';
import './styles/reset.css';
import './styles/tokens.css';
import './styles/typography.css';
import './styles/global.css';
import './styles/scene-products.css';
import './styles/shelf.css';
import './styles/aisle.css';
import './styles/product-details.css';
import './styles/product-offer.css';
import './styles/animations.css';

const root = document.querySelector<HTMLElement>('#app');
if (root) {
  mountApp(root);
}
